import { Component } from '@angular/core';

@Component({
  selector: 'app-brouillon-bn-recep',
  templateUrl: './brouillon-bn-recep.component.html',
  styleUrls: ['./brouillon-bn-recep.component.scss']
})
export class BrouillonBnRecepComponent {}
